<template>
  <div class="po-content" data-testid="po-row">
    <div class="po__page mb-48">
      <div class="row justify-content-between m-0">
        <div class="col-3 col-lg-3 content__total-row-border-less d-flex justify-content-between align-self-center align-items-center p-0 pr-8">
          <EpAddRowButton data-testid="bl-add-button" @add="$emit('add')" :isDisabled="shouldDisableAddButton"/>
          <EpLabel class="mb-0">Total</EpLabel>
        </div>
        <div class="col-9 col-lg-9 d-flex pl-lg-3 pr-0 align-self-center">
          <div>
            <EpLabel
              data-testid="total-rows-text"
              class="content__total-row mb-0"
              :class="{
                'text-danger': blsCountExceedMax,
                'border-danger': blsCountExceedMax
              }"
            >
              {{ blsCount }} / {{ maxBls }}
            </EpLabel>
          </div>
        </div>
      </div>
      <div v-if="blsCountExceedMax || posCountExceedMax" class="row m-0 mt-2 ep__laptop__display-error">
        <div v-if="blsCountExceedMax" class="col align-self-center error-message text-left">
          {{ getTextByCountry(countryCode, 'payPOPage_totalBLRecords_label_errorMsg_reachedMax', [maxBls]) }}
        </div>
        <div v-if="posCountExceedMax && !blsCountExceedMax" class="col align-self-center error-message text-left">
          {{ getTextByCountry(countryCode, 'payPOPage_totalPORecords_label_errorMsg_reachedMax', [maxPos]) }}
        </div>
      </div>
      <div v-if="blsCountExceedMax || posCountExceedMax" class="row ml-0 mr-0 mt-2 ep__tablet_display-error">
        <div class="col-3 col-lg-3"></div>
        <div class="col-9 col-lg-9 align-self-center">
          <div v-if="blsCountExceedMax" class="error-message text-left">
            {{ getTextByCountry(countryCode, 'payPOPage_totalBLRecords_label_errorMsg_reachedMax', [maxBls]) }}
          </div>
          <div v-if="posCountExceedMax && !blsCountExceedMax" class="error-message text-right">
            {{ getTextByCountry(countryCode, 'payPOPage_totalPORecords_label_errorMsg_reachedMax', [maxPos]) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EpLabel from '@/components/atoms/EpLabel.vue'
import { getTextByCountry } from '@/utils/displayTextResources'
import EpAddRowButton from '@/components/EpAddRowButton.vue'

export default {
  components: {
    EpLabel,
    EpAddRowButton
  },

  props: {
    maxBls: {
      type: Number,
      required: true
    },

    blsCount: {
      type: Number,
      required: true
    },

    posCount: {
      type: Number,
      required: true
    },

    maxPos: {
      type: Number,
      required: true
    },

    countryCode: {
      type: String
    }
  },

  computed: {
    shouldDisableAddButton () {
      return this.blsCountReachedMax || this.posCountExceedMax
    },

    blsCountReachedMax () {
      return this.blsCount >= this.maxBls
    },

    blsCountExceedMax () {
      return this.blsCount > this.maxBls
    },

    posCountExceedMax () {
      return this.posCount >= this.maxPos
    }
  },

  methods: {
    getTextByCountry
  }
}
</script>

<style lang="scss" scoped>

.text-danger {
  color: #ff0000 !important;
}

.error-message {
  color: #FF0000;
}

.border-danger {
  border-color: #ff0000 !important;
}

.content__total-row {
  padding-bottom: 11px;
  padding-top: 11px;
  padding-right: 8Px;
  padding-left: 8px;
  white-space: nowrap;
  width: max-content;
  display: flex;
  border: 1px solid #E1E1E1;
  box-sizing: border-box;
  border-radius: 5px;
}

.content__total-row-border-less {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}

@media (min-width: 1024px) {
  .ep__tablet_display-error {
    display: none !important;
  }
  .ep__paymentrow__col-2 {
    flex: 0 0 11.66667% !important;
    max-width: 11.66667% !important;
  }
  .ep__paymentrow__col-7 {
    flex: 0 0 63.3333% !important;
    max-width: 63.3333% !important;
  }
}

@media (max-width: 1023px) {
  .ep__laptop__display-error {
    display: none !important;
  }
}

</style>
